"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.function.name");
var _operationsConfig = require("@/api/community/operationsConfig");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'SearchSettings',
  data: function data() {
    return {
      form: {
        couponCards: [{
          path: '/pages/shop/cards/index',
          title: '礼品卡',
          subtitle: '把心意送给Ta',
          images: []
        }, {
          path: '/pages/shop/cards/index',
          title: '礼品卡',
          subtitle: '把心意送给Ta',
          images: []
        }],
        storeImages: []
      },
      dialogVisible: false,
      // 图片预览对话框显示状态
      dialogImageUrl: '',
      // 预览图片URL
      storeImagePath: '' // 门店图相对路径
    };
  },
  created: function created() {
    this.loadConfig();
  },
  methods: {
    loadConfig: function loadConfig() {
      var _this = this;
      // 读 ShopConfig id=1005（discover），结构 {discover:{banner:[{url,title,stitle,img_url}], shop:{img_url}}}
      // 映射到表单：banner[i] → couponCards[i]（url→path, stitle→subtitle, img_url→images[0].path）
      (0, _operationsConfig.getConfigById)(1005).then(function (res) {
        if (res.data && res.data.value) {
          try {
            var config = JSON.parse(res.data.value);
            var discover = config.discover || {};
            var banner = discover.banner || [];
            var shop = discover.shop || {};
            if (banner.length) {
              _this.form.couponCards = banner.map(function (card) {
                return {
                  path: card.url || '',
                  title: card.title || '',
                  subtitle: card.stitle || '',
                  images: card.img_url ? [{
                    url: (0, _operationsConfig.getImageUrl)(card.img_url),
                    name: 'image.jpg',
                    path: card.img_url
                  }] : []
                };
              });
            }
            if (shop.img_url) {
              _this.storeImagePath = shop.img_url;
              _this.form.storeImages = [{
                url: (0, _operationsConfig.getImageUrl)(_this.storeImagePath),
                name: 'store.jpg'
              }];
            }
          } catch (e) {/* 忽略 */}
        }
      });
    },
    addCard: function addCard() {
      this.form.couponCards.push({
        path: '',
        title: '',
        subtitle: '',
        images: []
      });
    },
    removeCard: function removeCard(index) {
      if (this.form.couponCards.length > 1) {
        this.form.couponCards.splice(index, 1);
      }
    },
    onReset: function onReset() {
      this.$refs.opsForm.resetFields();
      this.form.couponCards = [{
        path: '/pages/shop/cards/index',
        title: '礼品卡',
        subtitle: '把心意送给Ta',
        images: []
      }, {
        path: '/pages/shop/cards/index',
        title: '礼品卡',
        subtitle: '把心意送给Ta',
        images: []
      }];
      this.form.storeImages = [];
      this.storeImagePath = '';
    },
    onSubmit: function onSubmit() {
      var _this2 = this;
      // 表单 → discover 老结构：couponCards→banner（path→url, subtitle→stitle, images[0].path→img_url）
      //                       storeImages→shop（path→img_url）
      var banner = this.form.couponCards.map(function (card) {
        return {
          url: card.path || '',
          title: card.title || '',
          stitle: card.subtitle || '',
          img_url: card.images && card.images.length && card.images[0].path ? card.images[0].path : ''
        };
      });
      var shop = this.storeImagePath ? {
        img_url: this.storeImagePath
      } : {};
      var payload = {
        discover: {
          banner: banner,
          shop: shop
        }
      };
      (0, _operationsConfig.updateConfig)(1005, JSON.stringify(payload)).then(function () {
        _this2.$message.success('已保存首页探索设置');
        _this2.loadConfig();
      });
    },
    onExceed: function onExceed() {
      this.$message.warning('仅可上传一张图片');
    },
    // 图片预览
    handlePictureCardPreview: function handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    // 删除卡卷推荐图片
    handleRemove: function handleRemove(file, fileList, index) {
      this.form.couponCards[index].images = [];
    },
    // 卡卷推荐图片变化处理
    handleCardImageChange: function handleCardImageChange(file, fileList, index) {
      this.form.couponCards[index].images = fileList;
    },
    // 删除门店图片
    handleStoreRemove: function handleStoreRemove(file, fileList) {
      this.form.storeImages = fileList;
      this.storeImagePath = '';
    },
    // 门店图片变化处理 - 立即上传
    handleStoreImageChange: function handleStoreImageChange(file, fileList) {
      var _this3 = this;
      if (file && file.raw) {
        (0, _operationsConfig.uploadImage)(file.raw, '/').then(function (res) {
          _this3.storeImagePath = '/images/mall' + res.data;
          file.url = (0, _operationsConfig.getImageUrl)(_this3.storeImagePath);
          _this3.form.storeImages = [file];
        });
      }
    },
    // 触发文件输入
    triggerFileInput: function triggerFileInput(index) {
      this.$refs["fileInput".concat(index)][0].click();
    },
    // 处理文件选择 - 立即上传
    handleFileChange: function handleFileChange(event, index) {
      var _this4 = this;
      var file = event.target.files[0];
      if (!file) return;

      // 验证文件
      var isImage = file.type.indexOf('image/') === 0;
      var isLt2M = file.size / 1024 / 1024 < 2;
      if (!isImage) {
        this.$message.error('只能上传图片文件!');
        return;
      }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 2MB!');
        return;
      }
      (0, _operationsConfig.uploadImage)(file, '/').then(function (res) {
        // 保存时带 /images/mall（与老数据 /images/community/... 同为满路径，读侧只拼纯域名）
        var fullPath = '/images/mall' + res.data;
        var fileObj = {
          name: file.name,
          url: (0, _operationsConfig.getImageUrl)(fullPath),
          path: fullPath
        };
        _this4.form.couponCards[index].images = [fileObj];
      });

      // 清空input值，允许重复选择同一文件
      event.target.value = '';
    },
    // 上传前验证
    beforeUpload: function beforeUpload(file) {
      var isImage = file.type.indexOf('image/') === 0;
      var isLt2M = file.size / 1024 / 1024 < 2;
      if (!isImage) {
        this.$message.error('只能上传图片文件!');
        return false;
      }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 2MB!');
        return false;
      }
      return true;
    }
  }
};